// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2862":"css/app.6852","3678":"css/admin-app.6852"}[chunkId] + ".css";
};